import { render, staticRenderFns } from "./lor-facet-content-item.vue?vue&type=template&id=19a5669d&scoped=true&"
import script from "./lor-facet-content-item.ts?vue&type=script&lang=ts&"
export * from "./lor-facet-content-item.ts?vue&type=script&lang=ts&"
import style0 from "./lor-facet-content-item.scss?vue&type=style&index=0&id=19a5669d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5669d",
  null
  
)

export default component.exports